export default {
  title: 'Reference',
  description: 'Tato stránka obsahuje představení naší práce.',
};
